<div class="courses-grid-container">
  @if (isLoading()) {
    <div class="courses-grid__skeleton" aria-busy="true" aria-live="polite">
      <div class="courses-grid courses-grid--skeleton">
        @for (item of skeletonItems; track item) {
          <div class="courses-grid__skeleton-card"></div>
        }
      </div>
    </div>
  } @else if (isEmpty()) {
    <app-home-empty-state context="courses" />
  } @else {
    <app-info-banner
      class="courses-grid__banner"
      [title]="'app.components.coursesGrid.feedbackBannerTitle'"
      [message]="'app.components.coursesGrid.feedbackBannerText'"
      [ariaLabel]="'app.components.coursesGrid.feedbackBannerAria'"
      [translateTitle]="true"
      [translateMessage]="true"
      [translateAriaLabel]="true"
    />
    <div class="courses-grid">
      @for (course of courses(); track course.id) {
        <button
          type="button"
          class="courses-grid__card"
          (click)="openCourse(course.id)"
        >
          <app-course-card variant="parent" [course]="course"></app-course-card>
        </button>
      }
    </div>
  }
</div>
